import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d5c2d0f8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d5c2d0f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c2d0f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5c2d0f8')) {
      api.createRecord('d5c2d0f8', component.options)
    } else {
      api.reload('d5c2d0f8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d5c2d0f8&scoped=true", function () {
      api.rerender('d5c2d0f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Boys/PayCode/index.vue"
export default component.exports